export let ImageOrigin = /*#__PURE__*/function (ImageOrigin) {
  // Indicates that this image was shipped with the product as a standard image
  ImageOrigin[ImageOrigin["STANDARD"] = 0] = "STANDARD";
  // Indicates that this image is an override to a standard image
  ImageOrigin[ImageOrigin["OVERRIDE"] = 1] = "OVERRIDE";
  // Indicates that this image was added to the system as a customization
  ImageOrigin[ImageOrigin["CUSTOM"] = 2] = "CUSTOM";
  return ImageOrigin;
}({});
//# sourceMappingURL=ImageOrigin.js.map
